var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":("https://alia.iugu.com/receive/invoices/" + _vm.iugu),"target":"_blank"}},[_c('b-img',{staticClass:"px-1",attrs:{"src":_vm.iuguIcon,"width":"24px"}}),_vm._v(" Abrir no Iugu ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }